import * as React from 'react'
import { useSearchBillTos } from '@user/store/entityLocations'

import Search from '@mui/icons-material/Search'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import { Theme } from '@mui/material/styles'

type Props = Pick<
  ReturnType<typeof useSearchBillTos>,
  'searchText' | 'onChangeSearchText'
>

export const SearchBox: React.FC<Props> = (props) => (
  <TextField
    fullWidth
    variant="standard"
    placeholder="Search"
    data-test-id="searchBox"
    InputProps={{
      startAdornment: (
        <InputAdornment
          position="start"
          sx={{ marginLeft: (theme: Theme) => theme.spacing(2.5) }}
        >
          <Search />
        </InputAdornment>
      ),
    }}
    inputProps={{ 'data-test-id': 'searchText' }}
    value={props.searchText}
    onChange={props.onChangeSearchText}
  />
)
SearchBox.displayName = 'SearchBox'
